/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/

const projectConfigLoader = require('@root/config');
import plonevoltoSlate from '@plone/volto-slate';
import voltoActNetworkPloneSite from 'volto-act-network-plone-site';
import voltoUserProjects from 'volto-user-projects';
import projectmap from 'projectmap';

const addonsInfo = [{"name":"@plone/volto-slate","version":"18.9.1","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/opt/act/plone/act-network-plone-site/frontend/core/packages/volto-slate/src","packageJson":"/opt/act/plone/act-network-plone-site/frontend/core/packages/volto-slate/package.json","basePath":"/opt/act/plone/act-network-plone-site/frontend/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"volto-act-network-plone-site","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/act/plone/act-network-plone-site/frontend/packages/volto-act-network-plone-site/src","packageJson":"/opt/act/plone/act-network-plone-site/frontend/packages/volto-act-network-plone-site/package.json","basePath":"/opt/act/plone/act-network-plone-site/frontend/packages/volto-act-network-plone-site","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"volto-act-network-plone-site/*":["./src/*"]}],"addons":[]},{"name":"volto-user-projects","version":"0.1.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/act/plone/act-network-plone-site/frontend/packages/volto-user-projects/src","packageJson":"/opt/act/plone/act-network-plone-site/frontend/packages/volto-user-projects/package.json","basePath":"/opt/act/plone/act-network-plone-site/frontend/packages/volto-user-projects","tsConfigPaths":null,"addons":[]},{"name":"projectmap","version":"0.1.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/act/plone/act-network-plone-site/frontend/packages/volto-projectmap/src","packageJson":"/opt/act/plone/act-network-plone-site/frontend/packages/volto-projectmap/package.json","basePath":"/opt/act/plone/act-network-plone-site/frontend/packages/volto-projectmap","tsConfigPaths":null,"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}


const projectConfig = (config) => {
  return projectConfigLoader && typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, voltoActNetworkPloneSite, voltoUserProjects, projectmap];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
